import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { faBox, faCheck, faFileLines, faLocationDot, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faScanner } from '@fortawesome/pro-solid-svg-icons';
import { forkJoin } from 'rxjs';
import * as _ from 'underscore';
import { AuthService } from '../../../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { ConfirmationDialogComponent } from '../../../../../../partials/content/widgets/general/confirmation-dialog/confirmation-dialog.component';
import { MockSharedService, SHARED_SERVICE } from '../../../../../../shared/mockSharedService';
import { CropYear } from '../../../../../core/models/cropYear';
import { Room } from '../../../../../core/models/storage/room';
import { RoomLocation } from '../../../../../core/models/storage/room-location';
import { Warehouse } from '../../../../../core/models/storage/warehouse';
import { TenantWordsPipe } from '../../../../../core/pipes/tenant-words.pipe';
import { CropYearService } from '../../../../../core/services/crop-year.service';
import { PlatformConfigService } from '../../../../../core/services/platform-config.service';
import { RoomService } from '../../../../../core/services/storage/room-service';
import { WarehouseService } from '../../../../../core/services/storage/warehouse-service';
import { VarietyService } from '../../../../../core/services/variety.service';
import { PrinterDTO } from '../../../../estimates/models/printer-dto';
import { InventoryService } from '../../../../pick-plan/services/inventory.service';
import { PurchaseOrder } from '../../../../purchase-order/models/purchaseOrder';
import { PurchaseOrderService } from '../../../../purchase-order/services/purchaseorder.service';
import { SuppliersService } from '../../../../purchase-order/services/supplier.service';
import { HandlingUnitMasterDTO } from '../../../models/handling-unit-master';
import { InventoryAddItemPopupComponent } from '../../inventory-items/inventory-add-item-popup/inventory-add-item-popup.component';

export interface InventoryHumEditData {
  Hum?: HandlingUnitMasterDTO;
  Hums?: HandlingUnitMasterDTO[];
  barcode?: string;
  isBulkCreate?: boolean;
}

@Component({
  selector: 'inventory-hum-edit',
  templateUrl: './inventory-hum-edit.component.html',
  styleUrls: ['./inventory-hum-edit.component.scss']
})
export class InventoryHumEditComponent implements OnInit {
  @ViewChild('addItemPopup', { static: true }) public addItemPopup: InventoryAddItemPopupComponent;

  /** Opens Create / Bulk Add Inventory; afterClosed() emits the saved HUM (or bulk results), or null on cancel. */
  static open(dialog: MatDialog, data: InventoryHumEditData): MatDialogRef<InventoryHumEditComponent> {
    return dialog.open(InventoryHumEditComponent, { data, width: '1080px', maxWidth: '95vw', disableClose: true });
  }

  private destroyRef = inject(DestroyRef);
  public isLoading: boolean = true;
  public faTimes = faTimes;
  public faBox = faBox;
  public faCheck = faCheck;
  public faFileLines = faFileLines;
  public faLocationDot = faLocationDot;
  public faScanner = faScanner;
  public newHum: HandlingUnitMasterDTO = { handlingUnitDetails: [] };

  public searchWarehouse = "";
  public allWarehouses: Warehouse[] = [];
  public filteredWarehouseOptions: Warehouse[] = [];
  public defaultWarehouseSearchPrompt = `Please search for a ${this.pipe.transform("warehouse")}.`;
  public warehouseSearchPrompt: string = `Please search for a ${this.pipe.transform("warehouse")}.`;

  public searchRoom = "";
  public allRooms: Room[] = [];
  public filteredRoomOptions: Room[] = [];
  public defaultRoomSearchPrompt = `Please search for a ${this.pipe.transform("room")}.`;
  public roomSearchPrompt: string = `Please search for a ${this.pipe.transform("room")}.`;

  public searchLocation = "";
  public allLocations: RoomLocation[] = [];
  public filteredLocationOptions: RoomLocation[] = [];
  public defaultLocationSearchPrompt = `Please search for a ${this.pipe.transform("location")}.`;
  public locationSearchPrompt: string = `Please search for a ${this.pipe.transform("location")}.`;

  public isBulkCreate: boolean = false;
  public tagQty: number = 1;

  public allStatuses = [];
  private printer: PrinterDTO = {
    id: 0
  };
  public cropYearList: CropYear[] = [];
  public cloneYear: CropYear[] = [];
  poList: PurchaseOrder[] = [];
  isREPToken: boolean = false;
  filteredSearchOptions: PurchaseOrder[] = [];
  items: PurchaseOrder;
  searchPO: string = '';
  poSearchPrompt: string = `Please search Purchase Order.`;
  VendorList: any[];
  cloneVendor: any[];
  VarietyList: any[];
  cloneVariety: any[];
  VendorPrompt: string = 'Please search Vendor.'
  VarietyPrompt: string = 'Please search Variety.'
  CropYearPrompt: string = 'Please search Year.'
  searchVendor: string = '';
  searchVariety: string = '';
  searchCropYear: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InventoryHumEditData,
    private dialogRef: MatDialogRef<InventoryHumEditComponent>,
    private errorService: ErrorService,
    public pipe: TenantWordsPipe,
    public roomService: RoomService,
    private changeDetRef: ChangeDetectorRef,
    private dialog: MatDialog,
    public warehouseService: WarehouseService,
    private inventoryService: InventoryService,
    private authService: AuthService,
    private purchaseOrderService: PurchaseOrderService,
    private platformConfigService: PlatformConfigService,
    private suppliersService: SuppliersService,
    public varietyService: VarietyService,
    private cropYearService: CropYearService,
    @Inject(SHARED_SERVICE) private sharedService: MockSharedService, //Inject interface of shared service
  ) {
    // this.getAllConfigValues();
  }

  ngOnInit() {
    this.isLoading = true;

    if (this.data.isBulkCreate)
      this.isBulkCreate = this.data.isBulkCreate;

    if (this.data.Hum)
      this.newHum = JSON.parse(JSON.stringify(this.data.Hum));
    if (this.data.barcode)
      this.newHum.barcode = this.data.barcode;
    if (!this.newHum.handlingUnitDetails)
      this.newHum.handlingUnitDetails = [];
    this.newHum.handlingUnitDetails.forEach(x => { x.isChecked = true; });
    forkJoin([
      this.warehouseService.getWarehouses(),
      this.roomService.getRooms(),
      this.roomService.getRoomLocations(),
      this.inventoryService.getInventoryStatuses(),
      this.platformConfigService.getAllConfigValues()
      //, this.roomService.getRooms() 
    ])
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.allWarehouses = x[0];
        this.allRooms = x[1];
        this.allLocations = x[2];
        this.allStatuses = x[3];
        if (!!x[4] && x[4].length > 0) {
          //set true if erp token present
          this.isREPToken = !!x[4].find(x => x.name.includes("ERPNext:AccessToken")).value;
          if (this.isREPToken) {
            this.getPOfferNo();
          } else {
            this.isLoading = false;
          }
        }

        this.filterWarehouses();
        this.filterRooms()
        this.filterLocations();



        this.changeDetRef.detectChanges();
      }, error:err => {
        this.errorService.handleError(err);

        this.isLoading = false;
      }});

    this.GetVendor();
    this.GetVariety();
    this.GetCropYear();
  }

  setPrinter(printer: PrinterDTO) {
    this.printer = printer;
  }

  close(master) {
    this.dialogRef.close(master);
  }

  submit() {


    if (this.addItemPopup.hudReady) {
      this.addItemPopup.addItemToHum();
    }

    //set ERP flag true to save inventory in ERP from summary
    let isERPSave = true;


    if (this.newHum.handlingUnitDetails.length == 0) {
      const confRef = this.dialog.open(ConfirmationDialogComponent, {
        minWidth: '10%',
        data: {
          confirmLabel: 'Ok',
          title: 'Missing Requirements',
          confirmMessage: this.pipe.transform('Items') + ' must be added to inventory.',
          isWarning: true
        }
      });
    }
    else {
      this.isLoading = true;

      if (this.isBulkCreate) {


        let newHums: HandlingUnitMasterDTO[] = [];

        //Check if YCR, then only create 1 HUM
        var printQuantity = 1
        if (this.authService.hasTenant(["Yakima Chief Ranches", 'e7e73238-662f-4da2-b3a5-89f4abb87969'])) {

          printQuantity = this.tagQty;
          this.newHum.barcode = '';
          this.newHum.handlingUnitDetails.forEach(x => {
            x.quantity = this.tagQty * x.quantity;
          });
          newHums.push(this.newHum);
        } else {
          for (let i = 0; i < this.tagQty; i++) {
            this.newHum.barcode = '';
            newHums.push(this.newHum);
          }
        }

        this.inventoryService.postBulkInventoryHUM(newHums, this.printer.id, printQuantity,isERPSave).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:results => {
        if(this.isREPToken) this.createPR(newHums,results);
          this.close(results);
        },error: err => {
          this.errorService.handleError(err);
          this.isLoading = false;
          this.changeDetRef.detectChanges();
        }});

      } else {
        if (this.newHum.id) {
          this.inventoryService.putInventoryHUM(this.newHum).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
            this.close(x);
          },error: err => {
            this.errorService.handleError(err);
            this.isLoading = false;
            this.changeDetRef.detectChanges();
          }});
        }
        else {
          this.inventoryService.postInventoryHUM(this.newHum,isERPSave).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
            if(this.isREPToken) this.createPR([this.newHum],[x]);
            this.close(x);
          },error: err => {
            this.errorService.handleError(err);
            this.isLoading = false;
            this.changeDetRef.detectChanges();
        }});
        }
      }


    }
  }

  roomSelectionChanged(event?: string) {

    if (this.newHum.roomId) {
      let room = this.allRooms.find(x => x.id === this.newHum.roomId);


      if (!room) {
        this.filteredLocationOptions = [...this.allLocations];

        this.searchRoom = '';

        return;
      }


      this.newHum.roomName = room.name;
      this.newHum.warehouseId = room.warehouseId;

      this.newHum.roomLocationId = null;
      this.searchLocation = "";

    }

    else {
      this.newHum.roomId = null;
      this.newHum.roomLocationId = null;
      this.searchLocation = '';
    }

    this.filterLocations();

    this.changeDetRef.detectChanges();
  }

  filterLocation(event) {
    let tagNumber = event;
    let location = this.allLocations.find(x => x.barcode == tagNumber);
    let test = this.newHum.roomLocationId;

    let room = this.allRooms.find(x => x.barcode == tagNumber);

    let warehouse = this.allWarehouses.find(x => x.barcode == tagNumber);

    if (warehouse) {
      this.newHum.warehouseId = warehouse.id;
      return;
    }

    if (room) {
      this.newHum.roomId = room.id;
      this.newHum.warehouseId = room.warehouseId;
      return;
    }

    if (location) {
      this.newHum.roomLocationId = location.id;
      this.newHum.roomId = location.roomId;
      this.newHum.warehouseId = location.room.warehouseId;
      return;
    }
    this.changeDetRef.detectChanges();
  }



  filterLocations() {
    if (this.allLocations) {
      let filterValue = this.searchLocation.toLowerCase();
      let results = this.allLocations.filter(option => option.name.toLowerCase().includes(filterValue) && (option.roomId == this.newHum.roomId || !this.newHum.roomId));

      if (results.length > 20) {
        this.filteredLocationOptions = [];
        this.locationSearchPrompt = `Too many ${this.pipe.transform("locations")} found... please narrow your search.`
      } else {
        this.filteredLocationOptions = [...results];
        this.locationSearchPrompt = this.defaultLocationSearchPrompt;
      }
    }
  }
  filterWarehouses() {
    if (this.allWarehouses) {
      let filterValue = this.searchWarehouse.toLowerCase();
      let results = this.allWarehouses.filter(option => option.name.toLowerCase().includes(filterValue));

      if (results.length > 20 && !this.newHum.warehouseId) {
        this.filteredWarehouseOptions = [];
        this.warehouseSearchPrompt = `Too many ${this.pipe.transform("Warehouses")} found... please narrow your search.`
      } else {
        this.filteredWarehouseOptions = [...results];
        this.warehouseSearchPrompt = this.defaultWarehouseSearchPrompt;
      }
    }
    
  }
  warehouseSelectionChanged() {

    if (this.newHum.warehouseId) {
      let warehouse = this.allWarehouses.find(x => x.id === this.newHum.warehouseId);

      this.newHum.warehouseName = warehouse.name;

      this.filteredRoomOptions = this.allRooms.filter(x => x.warehouseId == warehouse.id);

      //this.locations = this.allLocations.filter(x => x.room.warehouseId == this.newHum.warehouseId)

      this.newHum.roomId = null;
      this.newHum.roomLocationId = null;
      this.searchLocation = "";
      this.searchRoom = "";
    }

    else {
      this.newHum.roomId = null;
      this.newHum.roomLocationId = null;
      // this.newHum.warehouseId = null;
    }

    this.changeDetRef.detectChanges();
  }

  filterRooms() {
    if (this.allRooms) {
      let filterValue = this.searchRoom.toLowerCase();
      let results = this.allRooms.filter(option => option.name.toLowerCase().includes(filterValue) && (option.warehouseId == this.newHum.warehouseId || !this.newHum.warehouseId));

      if (results.length > 20 && !this.newHum.warehouseId) {

        this.filteredRoomOptions = [];
        this.roomSearchPrompt = `Too many ${this.pipe.transform("rooms")} found... please narrow your search.`
      } else {

        this.filteredRoomOptions = [...results];
        this.roomSearchPrompt = this.defaultRoomSearchPrompt;
      }
    }
  }

  locationSelectionChanged(any?: string) {

    if (this.newHum.roomLocationId) {
      let location = this.allLocations.find(x => x.id === this.newHum.roomLocationId);

      if (!location) {
        this.searchLocation = '';
        return;
      }


      this.newHum.roomLocationName = location.name;



      let selectedWarehouse = this.allWarehouses.find(x => x.id === location.room.warehouseId);

      if (selectedWarehouse) {
        this.newHum.warehouseId = selectedWarehouse.id;
        this.newHum.warehouseName = selectedWarehouse.name;
        this.searchWarehouse = selectedWarehouse.name;
      }


      let room = this.allRooms.find(x => x.id == location.roomId);

      if (room) {
        this.newHum.roomId = room.id;
        this.newHum.roomName = room.name;
        this.searchRoom = room.name;
      }


      this.filterWarehouses();
      this.filterRooms();
      this.filterLocations();

      this.changeDetRef.detectChanges();

    }
    else {

      this.newHum.roomLocationId = null;
    }

    this.changeDetRef.detectChanges();
  }

  scan() {

    let dialogRef = this.sharedService.openDialog(
      "InventoryScanPopupComponent",
      this.dialog,
      {
        minWidth: "30%",
        data: {
          isHumEdit: true,
        },
      }
    );

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
      if (!x)
        return;

      this.searchLocation = "";
      this.searchWarehouse = "";
      this.searchRoom = "";

      if (x.isLocation) {
        this.newHum.roomLocationId = x.location.id;
        this.searchLocation = x.location.name;

        this.newHum.roomLocationId = x.location.id;
        this.searchRoom = x.location.room.name;

        this.searchWarehouse = x.location.room.warehouse.name
        this.newHum.warehouseId = x.location.room.warehouse.id;

        this.locationSelectionChanged();
      }

      if (x.isRoom) {
        this.newHum.roomLocationId = x.room.id;
        this.searchRoom = x.room.name;

        this.searchWarehouse = x.room.warehouse.name
        this.newHum.warehouseId = x.room.warehouse.id;

        this.searchLocation = '';
        this.newHum.roomLocationId = null;

        this.roomSelectionChanged();
      }

      if (x.isWarehouse) {
        this.searchWarehouse = x.warehouse.name
        this.newHum.warehouseId = x.warehouse.id;

        this.searchRoom = '';
        this.newHum.roomId = null;
        this.searchLocation = '';
        this.newHum.roomLocationId = null;


        this.warehouseSelectionChanged();
      }

      this.isLoading = false;
      this.changeDetRef.detectChanges();
    });
  }

  getPOfferNo() {
    this.isLoading = true;
    this.purchaseOrderService.getPOfferNo(this.newHum.vendorId, this.newHum.varietyId, this.newHum.cropYearId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: PurchaseOrder[]) => {
      this.isLoading = false;
      this.poList = response;
      this.filterPO();
      this.changeDetRef.detectChanges();
    }, err => {
      this.errorService.handleError(err);
      this.isLoading = false;
      this.changeDetRef.detectChanges();
    });
  }

  searchItemsabySelectedPO() {
    if (!!this.newHum.purchaseOrderId) this.getItemsbyPOId(this.newHum.purchaseOrderId);
  }

  //return matching data from list
  filterPO() {
    if (this.poList) {
      let filterValue = this.searchPO.toLowerCase();
      let results = this.poList.filter(option => option.offerNo ? option.offerNo.toLowerCase().includes(filterValue) : '');

      if (results.length > 20 && !this.newHum.purchaseOrderId) {
        this.filteredSearchOptions = [];
        this.poSearchPrompt = `Too many PO found... please narrow your search.`
      } else {
        this.filteredSearchOptions = [...results];
      }
    }
  }

  //Get items based on selected PO from dropdown.
  getItemsbyPOId(id: any) {
    if (!id) return;
    this.items = this.poList.find(x => x.id == id);
  }

  // Create PR in ERPNext
  createPR(payload: HandlingUnitMasterDTO[], results: any[]) {

    if (!!results && results.length > 0 && this.poList.length > 0) {
      payload = results;
      let po = this.poList.find(x => (results.map(x => x.purchaseOrderId) || []).includes(x.id.toString()));
      let erpId = !!po && po.hasOwnProperty('integrationId') ? po.integrationId : null;
      if (!!erpId) {
        payload.map(x => x.purchaseOrderERPId = erpId);

        let saveERPFlag = true;
        this.purchaseOrderService.createPR(payload, saveERPFlag).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: HandlingUnitMasterDTO[]) => {
        }, err => {
          this.errorService.handleError(err);
        });
      }
    }
  }

  GetVendor() {
    this.suppliersService.getSupplierList().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (results) => {
        this.VendorList = results;
        this.cloneVendor = results;
      },
      (err) => {
        this.errorService.handleError(err);
      }
    );
  }

  GetVariety() {
    this.varietyService.getVarieties().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (results) => {
        this.VarietyList = results;
        this.cloneVariety = results;
      },
      (err) => {
        this.errorService.handleError(err);
      }
    );
  }

  GetCropYear() {
    this.cropYearService.getCropYears().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
      x = _.sortBy(x, 'year').reverse();
      this.cropYearList = x;
      this.cloneYear = x;
    });
  }

  filterVendor() {
    let filterValue = this.searchVendor.toLowerCase();
    if(filterValue != ''){
      this.VendorList = this.VendorList.filter(option => option.contactName ? option.contactName.toLowerCase().includes(filterValue) : '');
    } else if (filterValue == '') {
      this.VendorList = this.cloneVendor;
    }
  }
  searchItemsabySelectedVendor() {
    if (!!this.newHum.vendorId) this.getItemsbyPOId(this.newHum.vendorId);
    this.getPOfferNo();
  }

  filterVariety() {
    let filterValue = this.searchVariety.toLowerCase();
    if(filterValue != ''){
      this.VarietyList = this.VarietyList.filter(option => option.name ? option.name.toLowerCase().includes(filterValue) : '');
    } else if (filterValue == '') {
      this.VarietyList = this.cloneVariety;
    }
  }
  searchItemsabySelectedVariety() {
    if (!!this.newHum.varietyId) this.getItemsbyPOId(this.newHum.varietyId);
    this.getPOfferNo();
  }

  filterCropYear(value:string) {
    if (value.length > 4) {
      value = value.split(value[4])[0];
    }
    this.searchCropYear = value;
    let filterValue = this.searchCropYear.toLowerCase();
    if(filterValue != ''){
      this.cropYearList = this.cropYearList.filter(option => option.name ? option.name.toLowerCase().includes(filterValue) : '');
    } else if (filterValue == '') {
      this.cropYearList = this.cloneYear;
    }
  }
  searchItemsabySelectedCropYear() {
    if (!!this.newHum.cropYearId) this.getItemsbyPOId(this.newHum.cropYearId);
    this.getPOfferNo();
  }
}
